import type en from "../en";

/**
 * Somali. The default locale — this is the language the product ships in.
 *
 * PLACEHOLDER TRANSLATIONS. Everything below was written by a developer, not a
 * Somali speaker, and should be reviewed before a pharmacy sees it. The
 * structure is what matters right now: the annotation on the next line is what
 * makes a missing or misspelled key a build failure rather than a screen that
 * quietly falls back to English.
 */
const so: typeof en = {
  /* ------------------------------------------------------------- general */
  appName: "FarmashiBook",
  updateTitle: "Cusbooneysii FarmashiBook",
  updateBody: "Noocaan waa hore, ma shaqeynaayo hada.Gal Play Store oo cusbooneysii si aad u sii isticmaashi. Xogtaada kaama lumeyso.",
  updateButton: "Cusbooneysii",
  closeApp: "Xir app-ka",

  deletePharmacy: "Tirtir koontada farmashiyaha",
  deleteWhat: (name: string) => `Tirtirka ${name} wuxuu meesha ka saarayaa, qof walba:`,
  deleteBranches: "Laan kasta",
  deleteStock: "Daawo kasta iyo kaydkeeda",
  deleteSales: "Iib kasta iyo rasiidh kasta",
  deleteCustomers: "Macmiil kasta iyo deynta lagu leeyahay",
  deleteStaff: "Galitaan kasta oo shaqaale",
  deleteSignsOut: "Taleefan kasta isla markiiba waa laga saarayaa.",
  deleteAfterDays: (phone: string) =>
    `30 maalmood kadib si buuxda ayaa loo tirtirayaa. Ilaa markaas, La xariir ${phone} si loo soo celiyo xogtaada farmashiga iyo koontadaada.`,
  deletePassword: "Furahaaga sirta, si aad u xaqiijiso",
  deleteForever: "Tirtir",
  deletedTitle: (name: string) => `${name} waa la tirtiray`,
  deletedBody: (date: string, phone: string) =>
    `Si buuxda ayaa loo tirtirayaa markii la gaaro ${date}. Ilaa markaas, wac taageerada ${phone} si loo soo celiyo.`,
  cancel: "Jooji",
  close: "Xir",
  back: "Dib u Laabo",
  next: "Xiga",
  save: "Kaydi",
  done: "La sameeyey",
  retry: "Isku day mar kale",
  loading: "Waa soo dhacayaa, sug…",
  offline: "Khadkaaga ma shaqeynaayo",
  offlineWorking: "Internet kuuma xariirsana. Isbeddellada aad sameyso waa la keydin doonaa marka aad internet hesho.",

  /* the web version's shared pieces (buttons, fields, lists). Somali to be checked by Ileyk. */
  showPassword: "Muuji furaha sirta ah",
  hidePassword: "Qari furaha sirta ah",
  previous: "Hore",
  loadMore: "Tus kuwo kale",
  clearSearch: "Tirtir raadinta",
  /* the web version's frame: menu, top bar. Somali to be checked by Ileyk. */
  billing: "Bixinta lacagta",
  more: "Kale",
  signOutConfirm: "Ma ka baxaysaa?",
  /* the web version's sign-in footer. Somali to be checked by Ileyk. */
  help: "Caawimaad",
  privacyPolicy: "Siyaasadda xogta gaarka ah",
  /* the web version's welcome and sign-in pages (computer layout). Somali to be checked by Ileyk. */
  webTagline: "Kaydka, iibka iyo deynta farmashigaaga, ka maamul kombiyuutarka iyo taleefanka.",
  /* The web's own words where the phone says "Tap" (a computer is clicked, a phone tapped). */
  webChooseDate: "Dooro taariikh",
  webPickToAddStock: "Dooro daawo si aad ugu darto kaydkeeda",
  webSelectToChange: "Dooro macmiilka ama daawo si aad u beddesho.",
  webNoSalesYet: "Weli iib ma jiro. Isticmaal Ku dar iib si aad u qorto kan ugu horreeya.",
  webFeatureStock: "Daawooyinka, kaydka iyo taariikhaha dhicitaanka",
  webFeatureSales: "Iibka, iyo rasiidhada WhatsApp-ka",
  webFeatureCredit: "Deynta: cidda lagu leeyahay iyo inta",
  webFeatureReports: "Warbixinno laan kasta",
  whoIsSigningIn: "Yaa soo galaya?",
  /* the web version's tables. Somali to be checked by Ileyk. */
  price: "Qiimaha",
  dateTime: "Taariikhda iyo saacadda",
  /* a page that could not load (web). Somali to be checked by Ileyk. */
  appUpdated: "FarmashiBook waa la cusboonaysiiyay. Dib u soo rar bogga si aad u sii wadato.",
  pageFailed: "Boggan lama furi karin.",
  reload: "Dib u soo rar",
  /* leaving a form with changes not saved (web). Somali to be checked by Ileyk. */
  discardChanges: "Ma tuurtaa isbeddellada?",
  discardChangesBody: "Waxa aad halkan ku qortay lama kaydin.",
  discard: "Tuur",

  /* ------------------------------------------------------------- dates */
  chooseDate: "Taabo si aad u doorato taariikh",
  pickDay: "Dooro taariikh",
  today: "Maanta",
  monthNames: [
    "Janaayo",
    "Febraayo",
    "Maarso",
    "Abriil",
    "Maajo",
    "Juun",
    "Luuliyo",
    "Ogosto",
    "Sebtembar",
    "Oktoobar",
    "Nofembar",
    "Desembar",
  ],
  /** Monday first. */
  weekdaysShort: ["Isn", "Tal", "Arb", "Kha", "Jim", "Sab", "Axd"],
  weekdays: ["Isniin", "Talaado", "Arbaco", "Khamiis", "Jimco", "Sabti", "Axad"],
  longDate: (weekday: string, day: number, month: string) => `${weekday} ${day} ${month}`,
  greeting: (partOfDay: "morning" | "afternoon" | "evening", name: string) =>
    `${partOfDay === "morning" ? "Subax wanaagsan" : partOfDay === "afternoon" ? "Galab wanaagsan" : "Fiid wanaagsan"}, ${name}`,
  todaysSales: "Iibka maanta",
  medicinesTotal: "Dawooyinka",
  inThisBranch: "Laantan",
  allTimeSales: "Dhamaan Iibka",
  allTime: "Waqti kasta",
  allTimeNeedsInternet: "xogta waqti kasta waxay u baahan yihiin internet hal mar.",
  recentSales: "Iibkii ugu dambeeyay",
  viewAll: "Arag Dhammaan",
  medicinesWord: (_n: number): string => "dawo",
  expiryCardHint: "Dhacay ama dhacaya 3 bil gudahood",
  outOfStockCardHint: (n: number) => `Dhammaaday, ama ka yar ${n} ayaa haray`,

  /* ---------------------------------------------------------------- auth */
  signIn: "Gal",
  signOut: "Ka bax",
  signInAsOwner: "Maamule",
  signInAsStaff: "Shaqaale",
  phone: "Lambarka taleefanka",
  password: "Furaha sirta ah",
  username: "Magaca isticmaalaha",
  currentPassword: "Furaha hadda",
  newPassword: "Fure cusub",
  changePassword: "Beddel furaha",
  forgotPassword: "Waan iloobay furahayga",
  verificationCode: "Koodhka",
  sendCode: "Dir koodhka",
  codeSentTo: (masked: string) => `Koodh ayaan u dirnay ${masked}.`,
  codeExpiresIn: (seconds: number) =>
    seconds >= 60
      ? `Koodhku wuxuu shaqaynayaa ${Math.round(seconds / 60)} daqiiqo.`
      : `Koodhku wuxuu shaqaynayaa ${seconds} ilbiriqsi.`,

  /* -------------------------------------------------------------- signup */
  welcomeTagline: "Farmashigaaga ka maamul taleefankaaga",
  signUp: "Isdiiwaangeli",
  signInOwnerIntro: "Isticmaal lambarka taleefanka ama iimaylka aad isku diiwaangelisay.",
  signInStaffIntro: "Isticmaal magaca iyo furaha uu maamulaha ku siiyay.",
  enterYourPhone: "Lambarka taleefanka",
  enterYourUsername: "Geli magacaaga isticmaalaha",
  noAccountSignUp: "Weli akoon ma sameysen? Isdiiwaangeli",
  haveAccountSignIn: "Hore ayaad akoon u lahayd? Gal",
  phoneOrEmail: "Lambarka taleefanka ama iimaylka",
  enterPhoneOrEmail: "Lambarka taleefanka ama iimaylka",
  email: "Iimayl",
  enterYourEmail: "Ciwaanka iimaylka",
  signUpWithPhone: "Ku diiwaangeli lambar taleefan beddelkeed",
  signUpWithEmail: "Ku diiwaangeli iimayl beddelkeed",
  signupEmailIntro: "Waxaan koodh u dirnaa iimaylkan si aan u hubinno inuu kaaga yahay.",
  signupEmailHint: "Kanu wuxuu noqonayaa iimaylka aad u isticmaali doonto galitaankaaga, iyo soo celinta furahaaga sirta hadii uu kaa lumo.",
  checkSpam: "koodh ma aadan arkin? Fiiri qeybta Spam-ka.",
  pharmacyPhoneHint: "Si farmashiga loola xiriiro. Si aad sidoo kale ugu isticmaasho soo galitaanka, mar dambe ku xaqiiji Profile-ka.",
  theirPhoneOrEmail: "Lambarka taleefankooda ama iimaylkooda",
  waysToSignIn: "Sida aad u gasho",
  notAdded: "Laguma darin",
  addContact: "Ku dar",
  addEmail: "Ku dar iimaylkaaga",
  changeEmail: "Beddel iimaylkaaga",
  addPhone: "Ku dar lambarka taleefankaaga",
  changePhone: "Beddel lambarka taleefankaaga",
  contactIntro: "Koodh ayaan u diri doonnaa. Markaad koodhka halkan ku qorto, lambarka appka waa kusoo geli kartaa, furahaagana sirta ahna waad ku soo celin kartaa hadii aad ilowdo.",
  contactSaved: "Waa la keydiyay. Hadda waad ku soo geli kartaa appka.",
  signInWaysNote: "Labadaba ku dar, si aadan u waayin qaab aad appka kusoo gasho hadii uu mid lumo.",
  backToSignIn: "Ku noqo galitaanka",
  sendCodeAgain: "Dib u dir koodhka",
  chooseNewPassword: "Dooro fure cusub",
  createPharmacy: "Diyaari farmashigaaga",
  pharmacyName: "Magaca farmashiga",
  branchName: "Magaca laanta",
  ownerName: "Magacaaga",
  signupPhoneIntro: "Waxaan koodh u dirney lambarkan si aan u hubinno inuu kaaga yahay.",
  signupPhoneHint: "Kanu wuxuu noqonayaa lambarka galitaankaaga, iyo sida kaliya ee aad furahaaga sirta ku soo celin karto hadii aad ilowdo.",
  signupDetailsIntro: "Tallaabada ugu dambeysa. Mar kale waad beddeli kartaa.",
  ownerPasswordHint: "Ugu yaraan 8 xaraf.",
  forgotPasswordIntro: "Geli lambarka taleefanka ama iimaylka aad ku gasho, waxaana kuu soo direynaa koodh.",
  staffNoRecovery: "Ma illowday furahaaga? Milkiilaha weydiiso inuu furo cusub kuu sameeyo.",

  /* ----------------------------------------------------------- the shell */
  home: "Guriga",
  account: "Akoonkayga",
  language: "Luqadda",

  /* ------------------------------------- settings, profile, pharmacy account */
  profile: "Xogtayda",
  pharmacyAccount: "Akoonka farmashiga",
  settingsYou: "Adiga",
  settingsPharmacy: "Farmashiga",
  settingsBranch: "Laanta",
  appearance: "Muuqaalka",
  themeLight: "Iftiin",
  themeDark: "Mugdi",
  helpSupport: "Caawimaad",
  helpSupportHint: "Su'aal, dhibaato, ama wax aan shaqaynayn? Nala soo xiriir.",
  callUs: "Na soo wac",
  whatsAppUs: "WhatsApp noogu soo dir",
  emailUs: "Iimayl noo soo dir",
  openFailed: "Taleefankani ma furi karo taas.",
  about: "Ku saabsan",
  termsOfUse: "Shuruudaha isticmaalka",
  termsUpdated: (date: string) => `La cusbooneysiiyay ${date}`,
  appVersion: "Nuqulka app-ka",
  whatYouCanDo: "Waxa aad samayn karto",
  phoneLetter: "Xarafka rasiidka ee taleefankan",
  pharmacyPhone: "Taleefanka farmashiga",
  currency: "Lacagta",
  timeZone: "Waqtiga",
  plan: "Qorshaha isticmaalka",
  planNames: { basic: "Aasaasi", pro: "Pro" },
  staffInUse: "Shaqaalaha",
  ofLimit: (n: number, limit: number | null) => (limit === null ? `${n}` : `${n} ka mid ah ${limit}`),
  /* Plan (Phase 6). No prices and no way to pay on the phone: Google Play's rules. */
  ok: "OK",
  planFreeForNow: "Bilaash hadda",
  planFree: "Bilaash",
  planFreeUntil: (day: string) => `Bilaash ilaa ${day}`,
  planPaidUntil: (day: string) => `La bixiyay ilaa ${day}`,
  planLine: (plan: string, standing: string) => `${plan} · ${standing}`,
  planEndingTitle: "Qorshaha isticmaalka ayaa dhammaanaya",
  planEndingBody: (daysLeft: number, day: string) =>
    daysLeft <= 0
      ? `Qorshahaaga isticmaalka wuxuu dhammaanayaa maanta, ${day}.`
      : daysLeft === 1
        ? `Qorshahaaga isticmaalka wuxuu dhammaanayaa berri, ${day}.`
        : `Qorshahaagaisticmaalka wuxuu dhammaanayaa ${daysLeft} maalmood kadib, ${day}.`,
  planEndedTitle: "Qorshaha isticmaalka waa dhammaaday",
  planGraceOwner: (ended: string, until: string) =>
    `Qorshahaaga isticmaalka wuxuu dhammaaday ${ended}. Wax walba way shaqeynayaan ilaa ${until}. Intaas kadib app-ku wuxuu noqonayaa daawasho keliya.`,
  planGraceStaff: "Qorshaha isticmaalka farmashiyaha waa dhammaaday. Fadlan u sheeg milkiilaha.",
  viewOnly: "Daawasho keliya",
  viewOnlyOwner: (from: string) =>
    `Daawasho keliya laga bilaabo ${from}. Waad arki kartaa, wadaagi kartaa, oo diiwaangelin kartaa deynta la soo celiyo. Iibka iyo beddelka kaydka waa la hakiyay ilaa qorshaha la cusbooneysiiyo.`,
  viewOnlyStaff: "Daawasho keliya. Weydii milkiilaha inuu cusbooneysiiyo qorshaha.",
  alreadyPaid: "Horay ma u bixisay? Ku xir internetka si uu u cusboonaado.",
  viewOnlyLine: "Daawasho keliya · qorshaha waa dhammaaday",
  viewOnlyStopOwner: "Qorshaha isticmaalka waa dhammaaday. Wax walba waad arki kartaa oo wadaagi kartaa, laakiin waxba lama beddeli karo ilaa qorshaha la cusbooneysiiyo.",
  viewOnlyStopStaff: "Qorshaha isticmaalka waa dhammaaday. Weydii milkiilaha inuu cusbooneysiiyo.",
  /* Billing page (web only: the phone shows no prices or way to pay). */
  seePlans: "Eeg qorshayaasha",
  daysLeft: (n: number) => (n === 1 ? "1 maalin ayaa harsan" : `${n} maalmood ayaa harsan`),
  graceUntil: (day: string) => `Wuu dhammaaday. Wax walba way shaqaynayaan ilaa ${day}.`,
  viewOnlySince: (day: string) => `Eegid kaliya laga bilaabo ${day}.`,
  choosePlan: "Dooro qorshe",
  planBranches: (n: number) => (n === 1 ? "1 laan" : `Ilaa ${n} laamood`),
  planStaff: (n: number | null) => (n === null ? "Shaqaale aan xad lahayn" : `Ilaa ${n} shaqaale`),
  planSameRest: "Wax kasta oo kale waa isku mid: iibka, kaydka, deynta, warbixinnada iyo wareejinta.",
  yourPlan: "Qorshahaaga",
  forMonths: (n: number) => (n === 1 ? "1 bil" : `${n} bilood`),
  perMonthPrice: (amount: string) => `${amount} bishii`,
  youSave: (amount: string) => `Waxaad badbaadinaysaa ${amount}`,
  howToPay: "Sida loo bixiyo",
  payWith: "Ku bixi",
  amountToPay: "Lacagta",
  dialThisCode: "Garaac koodhkan",
  scanToDial: "Ku sawir kamarada taleefankaaga: garaacuhu wuxuu ku furmayaa koodhka oo diyaar ah.",
  dialNow: "Hadda garaac",
  payStep1: "Garaac koodhka oo ku xaqiiji PIN-kaaga.",
  payStep2: "Magaca farmashiyahaaga ku soo dir WhatsApp.",
  payStep3: "Qorshahaaga waa la cusboonaysiinayaa marka aan xaqiijinno lacag-bixinta.",
  sendOnWhatsApp: "Ku dir WhatsApp",
  paymentMessage: (pharmacy: string, plan: string, period: string) => `Lacag-bixin: ${pharmacy}, ${plan}, ${period}`,
  planChangeNote: "U beddelidda Basic una gudubka Pro waxay dhaqan gelaysaa marka lacag-bixinta la xaqiijiyo. In ka badan 5 laamood? Nala soo xiriir.",
  planAllowsBranches: (n: number) => `Qorshahaagu wuxuu oggol yahay ${n} laan.`,
  planAllowsStaff: (n: number) => `Qorshahaagu wuxuu oggol yahay ${n} shaqaale.`,
  joined: "Ku biiray",
  nameOnReceipts: "Waxaa lagu daabacaa korka rasiid kasta, laan kasta.",
  pharmacyNeedsInternet: "Akoonka farmashigu wuxuu u baahan yahay internet.",
  role: "Doorka",
  roleOwner: "Milkiile",
  roleStaff: "Shaqaale",
  or: "ama",
  branch: "Laanta",
  branchCount: (n: number) => `${n} laan`,
  branches: "Laamaha",
  permissions: "Wuxuu gali karaa",
  shellComingSoon: "Qaybaha kale waxay la imanayaan alaabta iyo kaashka.",

  menu: "Liiska",
  sales: "Iibka",
  reports: "Warbixinnada",
  settings: "Dejinta",
  comingSoon: "Dhowaan",
  comingSoonBody: "Qaybtan app-ka weli waa la dhisayaa.",

  /* ------------------------------------------------------ staff management */
  staffMember: "Shaqaale",
  addStaffIntro: "Waxay ku gali doonaan magac isticmaale iyo fure taleefankooda.",
  theirName: "Magacooda",
  usernameHint: "Waa mid gaar ah farmashi kasta, haddii la qaatay, dooro mid ka mid kuwa aan kusoo jeediney ee hoos ka muuqda.",
  freeUsernames: "Hadda diyaar ah",
  defaultAccessNote: "Waxay ku bilaabmayaan kaashka iyo alaabta akhriska oo kaliya. Mar dambe beddel.",
  staffAdded: "Waa la daray",
  passwordShownOnce: "Tani waa markii kaliya ee la tusayo. Haddii la waayo, dib u deji — lama soo celin karo.",
  noStaffYet: "Weli cidna ma jirto. Ku dar qofkii ugu horreeyay.",
  deactivated: "la joojiyay",
  deactivate: "Ka Jooji isticmaalka",
  reactivate: "Dib u fur",
  deactivatedNote: "Ma geli karaan. Waxba lama tirtirin.",
  resetEndsSessions: "Dhammaan moobeelada ay ku isticmaaleyaan waa laga xirey. Fure la illoobay iyo taleefan la xaday halkan isku mid bay ka yihiin.",
  /* Owners (2026-10-12): one main owner; the others can only leave. */
  mainOwner: "Milkiilaha guud",
  invitationPending: "Martiqaadka weli lama aqbalin",
  makeMainOwner: "Ka dhig milkiilaha guud",
  makeMainOwnerAsk: (name: string) => `Ma ka dhigaysaa ${name} milkiilaha guud?`,
  makeMainOwnerBody:
    "Wuxuu awoodi doonaa inuu joojiyo milkiilayaasha kale, adiga ay ku jirto. Adigu milkiile ayaad ahaanaysaa. Geli furahaaga sirta si aad u xaqiijiso.",
  deactivateOwnerAsk: (name: string) => `Ma joojinaysaa ${name}?`,
  deactivateOwnerBody:
    "Isla markiiba waa laga saarayaa taleefan kasta, mana geli karo. Wax kasta oo uu diiwaangeliyay way sii jirayaan. Mar dambe dib ayaad u furi kartaa.",
  activateAgain: "Dib u fur",
  leavePharmacy: "Ka bax farmashiyahan",
  leavePharmacyBody:
    "Waa lagaa saarayaa taleefan kasta, mana geli kartid ilaa milkiilaha guud uu ku furo. Wax kasta oo aad diiwaangelisay way sii jirayaan. Geli furahaaga sirta si aad u xaqiijiso.",
  mainOwnerLeaveNote: "Si aad u baxdo, marka hore milkiile kale ka dhig milkiilaha guud.",
  onlyMainOwnerChanges: "Milkiilaha guud keliya ayaa joojin kara milkiilayaasha ama u wareejin kara doorkan.",
  mainOwnerNote: "Milkiilaha guud wuxuu joojin karaa milkiilayaasha kale, wuxuuna doorkan u wareejin karaa milkiile kale.",
  adminAreasNote: "Shaqaalaha, lacag-bixinta iyo diiwaanka dhaqdhaqaaqa weligood lama siin karo — adiga ayaa iska leh, wax kasta oo kor lagu shido.",

  /* ------------------------------------------------------- co-owners */
  inviteOwner: "Ku casuum milkiile",
  inviteOwnerIntro: "Milkiilaha wuxuu helayaa galitaankiisa, furahiisa, iyo magaciisa oo ku qoran fal kasta oo diiwaanka dhaqdhaqaaqa ah.",
  theirPhone: "Lambarka taleefankooda",
  enterTheirPhone: "Geli lambarkooda",
  theirPhoneHint: "Koodhku halkaas ayuu u socdaa, markaa waa inuu kooda yahay.",
  coOwnerNote: "Waxay awoodi doonaan wax kasta oo aad awoodo, oo ay ku jiraan maamulka shaqaalaha iyo lacag-bixinta. Ma jiro hab lagu casuumo qof milkiile qayb ah.",
  sendInvitation: "Dir casuumaadda",
  invitationSent: "Casuumaadda waa la diray",
  invitationSentNote: (name: string) => `${name} koodh ayaa loo diray.`,
  invitationNextSteps: "Waxay furayaan barnaamijka, waxay dooranayaan \u201cCasuumaad baan haystaa\u201d, waxayna gelinayaan koodhkaas iyo fure ay iyagu doortaan. Ilaa ay sidaas sameeyaan, ma geli karaan.",
  haveInvitation: "Casuumaad baan haystaa",
  acceptInvitation: "Aqbal casuumaadda",
  acceptInvitationIntro: "Geli lambarka taleefanka ama iimaylka casuumaadda loo diray, koodhka aad heshay, iyo fure aad adigu dooratay.",
  acceptInvitePhoneHint: "Kii milkiiluhu casuumay.",
  choosePassword: "Dooro fure",

  /* -------------------------------------------------------- own account */
  passwordChanged: "Furaha waa la beddelay.",
  passwordMinimum: (n: number) => `Ugu yaraan ${n} xaraf.`,
  changeEndsOtherSessions: "Fadhiyada kale oo dhan way dhammaanayaan. Kani wuu sii socon doonaa.",

  seeCostPrice: "Arag qiimaha iibsiga",
  seeCostPriceHint:
    "Waxa dufcad kasta ku kacday iyo celceliska. La'aantiis, qofku wali wuu qori karaa kayd.",

  sections: {
    pos: "Kaash",
    products: "Alaabta",
    batches: "Dufcadaha iyo dhicitaanka",
    purchases: "Ku darista alaabta iyo kaydka",
    transfers: "Wareejinta",
    customers: "Macaamiisha iyo deynta",
    invoices: "Qaansheegadaha",
    reports: "Warbixinnada",
    settings: "Habaynta",
  },

  /* --------------------------------------------------------------- staff */
  staff: "Shaqaalaha",
  addStaff: "Ku dar shaqaale",
  staffCount: (n: number) => `${n} qof`,
  handOverPassword: "Furahan sii. Hal mar ayaa la tusayaa.",
  resetPassword: "Dib u cusbooneysii furaha",
  resetPasswordAsk: (name: string) => `dib ma u cusbooneysiineysaa furaha ${name}?`,
  resetPasswordAskBody:
    "Furahoodii hore wuu shaqayn waayayaa isla markiiba, waxaana laga saarayaa telefoon kasta. Waxaad helaysaa furo cusub oo aad siiso.",
  yesReset: "Haa, dib u cusbooneysii",
  newPasswordFor: (name: string) => `Furaha cusub ee ${name}`,

  /* ------------------------------------------------------------ products */
  products: "Alaabta",
  searchProducts: "Ku raadi magaca, magaca Soomaaliga ama magaca guud",
  noProductsYet: "Weli waxba ma jiraan. Ku dar alaabta ugu horreysa.",
  noProductsFound: (q: string) => `Waxba kuma habboona "${q}".`,
  addProduct: "Ku dar alaab",
  tapToAddStock: "Taabo daawo si aad ugu darto kaydkeeda",
  noMedicinesYet: "Weli daawo ma jirto.",
  notInStore: (q: string) => `"${q}" kuma jirto bakhaarka.`,
  addNewMedicineNamed: (q: string) => `Ku dar "${q}" daawo cusub ahaan`,
  editDetails: "Wax ka beddel faahfaahinta",
  archived: "La kaydiyay",
  archiveProduct: "Kaydi",
  archiveProductHint:
    "Kama muuqan doonto raadinta iyo kaashka. Wixii hore loo iibiyay waa sii jiraan. Dib uga soo celi Dejinta → Daawooyinka la kaydiyay.",
  archivedMedicines: "Daawooyinka la kaydiyay",
  archivedMedicinesHint: "Dib u soo celi daawo aad kaydisay",
  archivedListNote: "Daawooyinka laantan lagu kaydiyay. Mid dib u soo celi, wuxuu ku soo noqonayaa Alaabta iyo kaashka, oo leh kaydkii uu lahaa.",
  bringBack: "Dib u soo celi",
  broughtBack: (name: string) => `${name} wuxuu ku soo noqday Alaabta.`,
  noArchived: "Laantan ma laha daawo la kaydiyay.",
  archivedNeedsInternet: "Daawooyinka la kaydiyay waxay u baahan yihiin internet.",

  /* the medicine */
  medicine: "Daawada",
  productName: "Magaca",
  productNameHint: "Sida ku qoran sanduuqa.",
  countedIn: "Lagu tiriyo",
  countedInHint: "Qadarka ugu yar ee aad iibiso. Kaydka oo dhan waxaa lagu tiriyaa kan.",
  countedInOptions: ["kiniin", "kaabsal", "xabbo", "ml", "bac", "dhalo", "tuubo", "fiyaal", "ambuul"],
  packOptions: ["xarig", "bac", "baakad", "dhalo", "sanduuq", "kartoon"],
  itComesIn: "Waxay ku timaadaa",
  itComesInHint: (unit: string) => `Taabo baakad kasta oo ay ku timaado. Midna, haddii ay kaliya ${unit} ku timaado.`,
  packOther: "Kale",
  packOtherLabel: "Magaca baakadda",
  packInside: (inner: string, pack: string) => `${inner} ku jira 1 ${pack}`,
  packEquals: (pack: string, n: number, base: string) => `1 ${pack} = ${n} ${base}`,
  howManyAdded: (pack: string) =>
    `Tirooyinka waa la isku darayaa, wadartana adiga ayaa laguu xisaabinayaa. Haddii dhammaan ay ${pack} ku yimaadeen, kaliya taas qor.`,
  howManyHave: "Immisa ayaad haysaa",
  sellingPrice: "Qiimaha iibka",
  countedInOther: "Wax kale",
  moreDetails: "Faahfaahin dheeraad ah",
  fewerDetails: "Faahfaahin yar",
  productNameSo: "Magaca Soomaaliga",
  productNameSoHint: "Waxa macmiilku weydiisto. Waxaa loo isticmaalaa raadinta.",
  genericName: "Magaca guud",
  genericNameHint: "Daawada ku jirta, sida paracetamol.",
  strength: "Xoogga",
  strengthHint: "Sida 500mg",
  form: "Nooca",
  formHint: "Sida kiniin, sharoobo, irbad",
  manufacturer: "Soo saaraha",
  originCountry: "Dalka",
  category: "Qaybta",
  barcode: "Barcode",
  barcodeHint: "waxba haku qorin haddii sanduuqu aanu lahayn.",
  isRx: "Rijeeto u baahan",
  noExpiry: "Ma lahan taariikh dhicitaan",
  fromMedicineList: "Liiska daawooyinka",
  noExpiryHint: "Saabuun, sakiin iyo wax la mid ah. Daawooyinku mar walba way leeyihiin.",
  reorderLevel: "I ogeysii marka kaydku ka hooseeyo",
  reorderLevelHint: (unit: string) => `Lagu tiriyo ${unit}.`,

  /* this stock */
  thisStock: "Kaydkan",
  size: "Cabbirka",
  newSize: "Cabbir cusub",
  sizeLabel: "Magaciisa",
  sizeLabelHint: "Sida sanduuq, xarig, kartoon",
  sizeCount: (unit: string) => `Immisa ${unit} ayaa ku jira?`,
  howMany: "Immisa",
  costEach: (size: string) => `Qiimaha uu ku fadhiyo ${size} kasta`,
  priceEach: (size: string) => `Qiimaha aad iibiso ${size} kasta`,
  priceEachHint:
    "Beddel keliya haddii qiimuhu kor u kacayo ama hoos u dhacayo. Wuxuu khuseeyaa dhammaan cabbirkan.",
  expiryDate: "Taariikhda dhicitaanka",
  lotNumber: "Lambarka dufcadda",
  lotNumberHint: "Wuxuu ku qoran yahay sanduuqa. waxba haku qorin haddii aanu jirin.",
  supplier: "Qofka aad ka soo iibsatey alaabta",
  noSupplier: "Midna",
  orTypeNew: "Ama qor magaca qof cusub",
  dateReceived: "Taariikhda la helay",
  totalPaid: (amount: string) => `Wadarta la bixiyay: ${amount}`,
  confirmExpired: "Kaydkan horey ayuu u dhacay",
  confirmExpiredBody:
    "Ma la qoraa si kastaba? Waa laga soocayaa kaydka kale, kaashkuna wuu digniin doonaa ka hor intaan la iibin.",
  recordAnyway: "Qor",
  lotProblem: {
    expiry_required: "Tani waa daawo. Qor taariikhda dhicitaanka.",
    expiry_in_past: "Horey ayuu u dhacay.",
    qty_not_positive: "Immisa?",
    qty_not_whole: "Qor tiro dhan.",
    cost_negative: "Qiimuhu ma noqon karo mid taban.",
    no_lots: "Qor kaydka.",
  },

  /* one product */
  stock: "Kaydka",
  inStore: "Bakhaarka ku jira",
  batchCount: (n: number) => `${n} dufcad`,
  avgCost: "Celceliska qiimaha",
  nearestExpiry: "Dhicitaanka ugu dhow",
  expired: "Wuu dhacay",
  expiresSoon: "Dhowaan buu dhacayaa",
  sizesAndPrices: "Cabbirrada iyo qiimaha",
  holds: (qty: string) => `Waxaa ku jira ${qty}`,
  addSize: "Ku dar cabbir",
  batches: "Dufcadaha",
  batchLeft: (left: string, received: string) => `${left} ayaa ka hadhay ${received}`,
  received: "La helay",
  perUnit: (unit: string) => `${unit} kasta`,
  cost: "Qiimaha iibsiga",
  correctCost: "Sax",
  costOfOne: (size: string) => `Qiimaha hal ${size}`,
  correctCostHint: "Iibyadii horay looga sameeyay kaydkan sidoo kale waa la saxayaa, si faa'iidadu u saxnaato.",
  batchStatus: {
    active: "Bakhaarka ku jira",
    quarantined: "Wuu dhacay",
    written_off: "La tirtiray",
  },

  /* changing a quantity */
  change: "Beddel",
  nowHave: (qty: string) => `Hadda: ${qty}`,
  newNumber: (unit: string) => `Immisa ${unit} ayaa hadda jira?`,
  equalsSize: (text: string) => `= ${text}`,
  why: "Maxaa sabab ah?",
  adjustReason: {
    expired: "Wuu dhacay",
    damaged: "Wuu burburay",
    missing: "Wuu maqan yahay",
    returned: "Waa loo celiyay alaab-qeybiyaha",
    counted_wrong: "Si khaldan ayaa loo tiriyay",
    other: "Wax kale",
  },
  messageOptional: "Fariin (ikhtiyaari)",
  messageRequired: "Fariin: sheeg waxa dhacay",
  adjustProblem: {
    not_a_number: "Qor tiro dhan.",
    below_zero: "Kama yaraan karto eber.",
    unchanged: "Taasi waa tirada hadda jirta.",
    reason_cannot_raise: "Kaliya Si khaldan ayaa loo tiriyay ama Wax kale ayaa kordhin kara tirada.",
    note_required: "Sheeg waxa dhacay.",
    invalid_receipt_no: "Lambarkaas rasiidhku kama tirsana taleefankan.",
    receipt_taken: "Iib kale ayaa horey u haysta lambarkaas rasiidh.",
  },
  changes: "Isbeddellada",
  changeBy: (who: string, date: string) => `${who} · ${date}`,
  ofBatch: (expiry: string) => `Dufcadda ${expiry}`,

  /* expiry */
  expiry: "Dhicitaanka",
  expiryGroup: {
    expired: "Wuu dhacay",
    month1: "1 bil gudaheed",
    month2: "2 bilood gudahood",
    month3: "3 bilood gudahood",
  },
  medicineCount: (n: number) => `${n} daawo`,
  nothingExpiring: "Waxba ma dhicin, waxna ma dhacayaan 3da bilood ee soo socda.",
  nothingInGroup: "Waxba halkan ma jiraan.",
  stockAtRisk: (amount: string) => `${amount} oo kayd ah`,
  expiresOn: (date: string) => `Wuxuu dhacayaa ${date}`,
  expiredOn: (date: string) => `Wuxuu dhacay ${date}`,
  qtyLeft: (qty: string) => `${qty} ayaa hadhay`,

  /* ---------------------------------------------------------------- till */
  noneLeft: "Waxba ma hadhin",
  tillShort: (left: string, selling: string, after: string) =>
    `Kaydku waa dhammaaday: ${left} kaliya ayaa hadhay. Iibinta ${selling} waxay ka dhigaysaa ${after}.`,
  tillShortNone: (selling: string, after: string) =>
    `Kaydku waa dhammaaday: waxba ma hadhin. Iibinta ${selling} waxay ka dhigaysaa ${after}.`,
  tillExpired: (date: string) => `Qayb ka mid ah kaydkan wuxuu dhacay ${date}.`,
  soldWithoutStock: "La iibiyay kayd la'aan",
  soldWithoutStockHint: "Kaydka xiga ee aad qorto ayaa marka hore daboolaya kan.",

  /* cart */
  total: "Wadarta",
  chargedEach: (size: string) => `Qiimaha ${size} kasta`,
  normalPrice: (price: string) => `Qiimaha caadiga ah ${price}`,
  notAnAmount: "Dhibicda kadib isticmaal ugu badnaan 10 tiro, sida 0.005.",
  enterPrice: "Qor qiimaha.",

  /* payment */
  nothingToPay: "Iibkan waxba kuma kacayo, markaa wax la bixiyo ma jiro.",
  finishSale: "Dhammee iibka",

  /* checking the sale before it is finished */
  checkSale: "Hubi iibka",
  tapToChange: "Taabo macmiilka ama daawo si aad u beddesho.",
  customer: "Macmiil",
  addCustomer: "+ Ku dar macmiil",
  changeCustomer: "Beddel",
  paid: "La bixiyay",
  sellOnCredit: "Ku iibi deyn",
  paidNow: "Hadda la bixiyay",
  subtotal: "Wadarta hore",
  discount: "Qiimo dhimis",
  discountTooBig: "Qiimo dhimisku kama badnaan karo iibka.",
  discountNegative: "Qiimo dhimista ku qor calaamad la'aan.",
  creditTooMuch: "Deyntu kama badnaan karto wadarta.",
  colNo: "No",
  colProduct: "Alaabta",
  colQty: "Tirada",
  colPrice: "Qiimaha",
  colAmount: "Lacagta",

  /* receipt */
  receipt: "Rasiidh",
  receiptNo: (n: string) => `Rasiidh ${n}`,
  shareToWhatsApp: "U dir WhatsApp",
  shareFailed: "Lama wadaagi karin. Rasiidhku weli halkan ayuu yaal, sawir ka qaad.",
  newSale: "Iib cusub",

  /* --------------------------------------------------------------- sales */
  addSale: "Ku dar iib",
  continueSale: (total: string) => `Sii wad iibka · ${total}`,
  continueEditing: (receiptNo: string) => `Sii wad beddelka rasiidh ${receiptNo}`,
  searchSales: "Magac, taleefan, rasiidh ama daawo",
  filterDate: "Taariikhda",
  allDates: "Tus dhammaan taariikhaha",
  noSalesYet: "Weli iib ma jiro. Taabo Ku dar iib si aad u qorto kan ugu horreeya.",
  noSalesFound: "Iib u dhigma lama helin.",
  edited: "La beddelay",
  cancelledTag: "La joojiyay",

  /* one sale */
  soldBy: (name: string) => `waxaa iibiyay ${name}`,
  editSale: "Wax ka beddel",
  editedBy: (name: string, when: string) => `Waxaa beddelay ${name}, ${when}`,
  cancelledBy: (name: string, when: string) => `Waxaa joojiyay ${name}, ${when}`,
  whyWas: (reason: string) => `Sababta: ${reason}`,
  changeAdded: (name: string, what: string) => `${name}: lagu daray, ${what}`,
  changeRemoved: (name: string) => `${name}: laga saaray`,
  changePricePart: (before: string, after: string) => `qiimaha ${before} \u2192 ${after}`,
  totalChange: (before: string, after: string) => `Wadarta ${before} \u2192 ${after}`,
  cancelWindowOver: "Iib waxaa la joojin karaa kaliya 14 maalmood gudahood.",
  tooOldToEdit: "Iibkan wuxuu dhaafay 30 maalmood. Lama beddeli karo, lamana joojin karo.",
  unfinishedSale: "Iib aan dhammaan ayaa jira",
  finishOtherSaleFirst: "Dhammee ama jooji ka hor intaadan beddelin iib kale.",
  openUnfinished: "Fur",
  cancelSale: "Jooji iibka",
  cancelSaleConfirm: "Ma hubtaa inaad joojinayso iibkan? Weli waxba lama qorin.",
  cancelRecordedConfirm: "Ma hubtaa inaad joojinayso iibkan? Daawooyinku waxay ku noqonayaan kaydka.",
  yesCancelSale: "Haa, jooji",
  keepSale: "Maya, ha joojin",
  cancelWhyHint:
    "Daawooyinku waxay ku noqonayaan kaydka. Iibku wuu ku sii jiraa taariikhda, isagoo ku calaamadaysan La joojiyay.",
  editWhyHint: "Rasiidhku lambarkiisa ayuu haystaa, iibkuna wuxuu muujinayaa waxa isbeddelay.",
  saleReason: {
    returned: "Macmiilka ayaa soo celiyay",
    wrong_medicine: "Daawo khaldan",
    wrong_quantity: "Tiro khaldan",
    wrong_price: "Qiime khaldan",
    other: "Wax kale",
  },

  /* add sale */
  editingSale: (receiptNo: string) => `Beddel rasiidh ${receiptNo}`,
  customerName: "Magaca macmiilka (ikhtiyaari)",
  customerPhone: "Taleefanka macmiilka (ikhtiyaari)",
  invalidPhone: "Lambarkaasi sax ma aha.",
  pickMedicine: "Qor ama dooro daawo",
  mostSold: "Kuwa ugu iibka badan",
  changeMedicine: "Beddel",
  changePrice: "Beddel qiimaha",
  useNormalPrice: "Isticmaal qiimaha caadiga ah",
  removeMedicine: "Ka saar daawadan",
  addAnotherMedicine: "+ Ku dar daawo kale",
  newMedicine: "Daawo cusub",
  soldAs: "Waxaa lagu iibiyaa",
  newMedicineHint: "Kaliya waxa iibkan u baahan yahay. Kaydkeeda, qiimaha iibsiga iyo dhicitaanka hadhow ku qor Alaabta.",
  saveAndSell: "Kaydi oo iibi",
  stopEditing: "Jooji beddelka",
  stopEditingConfirm: "Ma joojinaysaa beddelka? Iibku sidiisii ayuu ahaanayaa.",
  saveChanges: "Kaydi isbeddelka",

  /* -------------------------------------------------- this phone's copy */
  syncFirstTime: "Daawooyinka ayaa la soo dejinayaa taleefankan…",
  syncUpdating: "Waa la cusboonaysiinayaa…",
  syncUpToDate: (time: string) => `Wax walba waa cusub yihiin · ${time}`,
  syncOffline: (time: string | null) =>
    time
      ? `internet-ka ma shaqeynaayo · cusboonaysiintii ugu dambaysay ${time}`
      : "internet-ka ma shaqeynaayo · weli waxba kuma jiraan taleefankan",
  syncFailing: (time: string | null) =>
    time ? `Server-ka lama gaari karo · cusboonaysiintii ugu dambaysay ${time}` : "Server-ka lama gaari karo",
  clockWrong: (phone: string, real: string) =>
    `Taariikhda ama saacadda taleefankan waa khalad. Waxay muujinaysaa ${phone}, laakiin waa ${real}. Ku sax dejinta taleefanka: rasiidhadu waxay qaataan waqtiga taleefanka.`,
  syncSending: (n: number) => `Waa la dirayaa ${n}…`,
  syncWaitingOffline: (n: number) => `${n} ayaa sugaya in la diro · waxay tagayaan marka internetku soo laabto`,
  syncRefused: (n: number) => `${n} server-ku ma aqbalin · taabo si aad u aragto`,
  needFirstSync: "Taleefankani wuxuu u baahan yahay internet hal mar si uu u helo xarafkiisa lambarrada rasiidhada. Ku xidh, sug wax yar, oo isku day mar kale.",
  waitingToSendNote: "Waxay sugaysaa in la diro. Waxay ku kaydsan tahay taleefankan, iskeedna way u tagaysaa server-ka marka internet jiro.",
  notAcceptedNote: (reason: string) => `Server-ku ma aqbalin iibkan: ${reason}`,
  offlineProductNote: "Xiriir ma jiro: kani waa nuqulka taleefankan ku kaydsan, laantan. Isbeddelka halkan ayaa lagu kaydiyaa, waxaana la diraa marka internet jiro.",
  savedOnPhone: "Taleefankan ayaa lagu kaydiyay. Si iskiis ah ayaa loo diri doonaa marka internet jiro.",
  notAcceptedTitle: "Lama aqbalin",
  notAcceptedHint: "Server-ku ma qaadan kuwan. Isku day mar kale marka dhibaatada la xalliyo, ama ka saar isbeddelka.",
  notAcceptedSale: (receiptNo: string) => `Iibka ${receiptNo}: milkiilayaashu waxay ku arkaan Wax u baahan fiiro.`,
  notAcceptedCancel: (receiptNo: string) => `Joojinta rasiidh ${receiptNo}: milkiilayaashu waxay ku arkaan Wax u baahan fiiro.`,
  notAcceptedCredit: (name: string, receiptNo: string | null) =>
    receiptNo ? `Deyn ${name} · rasiidka ${receiptNo}` : `Deyn ${name}`,
  notAcceptedCreditChange: (name: string) => `Beddelka deynta ${name}`,
  changeCredit: "Beddel deyntan",
  changeCreditHint: "Qalad ma ku qortay? Geli lacagta saxda ah iyo waxa ay u tahay.",
  removeCredit: "Tirtir deynta",
  removeCreditConfirm: "Ma tirtiraysaa deyntan? Waxay ka baxaysaa waxa lagu leeyahay.",
  keepCredit: "Ha tirtirin",
  creditChanged: "Deynta waa la beddelay.",
  wasAmount: (amount: string) => `Hore: ${amount}`,
  notAcceptedEdit: (receiptNo: string) => `Beddelka rasiidh ${receiptNo}: milkiilayaashu waxay ku arkaan Wax u baahan fiiro.`,
  notAcceptedChange: (reason: string) =>
    `Server-ku ma aqbalin beddelkan: ${reason} Milkiilayaashu waxay ku arkaan Wax u baahan fiiro.`,
  changedFirst:
    "Taleefan kale ayaa horay u beddelay iibkan, sidaas darteed beddelkan lama samayn. Milkiilayaashu waxay ku arkaan Wax u baahan fiiro, iyagaana go'aaminaya.",
  stockChangeLine: {
    product: (name: string) => `${name}: lagu daray, kaydkiisii ugu horreeyay`,
    stock: (name: string) => `${name}: kayd la diiwaangeliyay`,
    adjust: (name: string, delta: string) => `${name}: tirada waa la beddelay ${delta}`,
    details: (name: string) => `${name}: faahfaahinta waa la beddelay`,
    price: (name: string) => `${name}: qiimaha waa la beddelay`,
    size: (name: string) => `${name}: cabbir lagu daray`,
    archive: (name: string) => `${name}: waa la kaydiyay`,
    cost: (name: string) => `${name}: kharashka waa la saxay`,
  },
  removeChange: "Ka saar",
  nothingNotAccepted: "Waxba ma jiraan: wax walba waa la aqbalay.",
  removeChangeConfirm: "Ma ka saaraysaa isbeddelkan taleefanka? Lama diri doono.",
  offlineExpiryNote: "Xiriir ma jiro: waxaa la muujinayaa laantan, nuqulka taleefankan ku kaydsan.",
  offlineSaleNote:
    "internet-ka ma shaqeynaayo: kani waa nuqulka taleefankan ku kaydsan. Joojin ama beddel halkan ayaa lagu kaydinayaa, waxaana la dirayaa marka internet jiro.",
  historyOffline: "internet-ka ma shaqeynaayo: waxaa la tusayaa 7-dii maalmood ee ugu dambeeyay ee taleefankan ku kaydsan.",
  waitingTag: "Sugaya in la diro",
  notAcceptedTag: "Lama aqbalin",
  cannotSignOutYet: (n: number) =>
    `${n} iib weli ma gaarin server-ka. Haddii aad ka baxdo way lumayaan. Internet ku xidh oo sug ilaa xariiqda xaaladdu ay sheegto in wax walba la diray.`,

  thisPhone: (letter: string) => `Taleefankan: ${letter}`,

  /* ----------------------------------------------------------- transfers */
  transfersTitle: "Wareejinta",
  status: "Xaaladda",
  toReceiveTab: (n: number) => `La helayo (${n})`,
  sentTab: "La diray",
  receivedLately: "Dhawaan la helay",
  nothingToReceive: "Wax halkan ku soo socda ma jiraan.",
  nothingSent: "Weli waxba lama dirin.",
  sendStock: "Dir kayd",
  sendTo: "U dir",
  addMedicineToSend: "Ku dar daawo",
  searchThisBranch: "Ka raadi daawooyinka laantan",
  whichBatch: "Kee dufcad?",
  howManyToSend: (unit: string) => `Immisa ${unit}?`,
  onlyThisMany: (qty: string) => `Waxaa jira kaliya ${qty}.`,
  addToTransfer: "Ku dar",
  sendNow: "Dir",
  transferState: {
    dispatched: "Waa soo socdaa",
    received: "Waa la helay",
    discrepancy: "Waa la helay, waa ka yar yahay",
    cancelled: "Waa la joojiyay",
  },
  fromTo: (from: string, to: string) => `${from} → ${to}`,
  sentBy: (name: string, date: string) => `Waxaa diray ${name} · ${date}`,
  receivedBy: (name: string, date: string) => `Waxaa helay ${name} · ${date}`,
  sentQty: (qty: string) => `La diray: ${qty}`,
  arrivedQty: (qty: string) => `Yimid: ${qty}`,
  receivedAs: (name: string) => `Loo helay sida ${name}`,
  whichOfYours: "Daawooyinkaaga midkee waa tan?",
  anotherOfMine: "Mid kale oo aan leeyahay",
  addAsNew: "Ku dar daawo cusub",
  newPricesHint: "Qiimaha iibka ee aad adigu dhigayso cabbir kasta.",
  howManyArrived: (unit: string) => `Immisa ${unit} ayaa yimid?`,
  whyFewer: "Maxay u yimaadeen wax ka yar?",
  shortfall: {
    missing: "Maqan",
    damaged: "Waxyeelloobay",
    other: "Wax kale",
  },
  arrivesHereAs: (qty: string) => `Halkan wuxuu ku imaanayaa ${qty}`,
  notWholeHere: (unit: string) => `Taasi ma aha tiro dhan oo ${unit} ah, oo daawadaadu ku tirsan tahay.`,
  countIn: "Ku tiri",
  addMedicineLink: "+ Ku dar daawo",
  checkBeforeSending: "Hubi ka hor intaadan dirin",
  toBranch: (name: string) => `U socda ${name}`,
  changeAmount: "Beddel tirada",
  editLine: "Wax ka beddel",
  notEnoughForAll: (name: string) => `${name} kuguma filna laan kasta.`,
  editingTransfer: (name: string) => `Waxaad beddelaysaa waxa u socda ${name}`,
  cancelTransfer: "Jooji wareejinta",
  cancelTransferConfirm: "Ma joojinaysaa wareejintan? Wax walba waxay ku noqonayaan shelf-ka laantan.",
  yesCancelTransfer: "Haa, jooji",
  editTransfer: "Wax ka beddel",
  correctSent: "Sax tirada la diray",
  correctArrived: "Sax tirada timid",
  correctWeekHint: "Waa suurtagal toddobaad gudihiis kadib markii la helay.",
  changeKind: {
    edited: "Wax laga beddelay",
    cancelled: "La joojiyay",
    sent_corrected: "Tirada la diray waa la saxay",
    arrived_corrected: "Tirada timid waa la saxay",
  },
  changeLine: (name: string, from: string, to: string) => `${name}: ${from} → ${to}`,
  keepTransfer: "Maya, hay joogto",
  transferChanges: "Isbeddelada",
  noChangesToSave: "Waxba lama beddelin.",
  receivedButton: "Waa la helay",
  stockToReceive: (n: number) => `Kayd la helayo (${n})`,
  transfersNeedInternet: "Wareejintu waxay u baahan tahay xiriir. Xiriir oo isku day mar kale.",

  /* ------------------------------------------------------------ branches */
  workingIn: (name: string) => `Laanta: ${name}`,
  switchBranch: "Beddel laanta",
  switchBranchHint: "Wax kasta oo aad aragto — daawooyinka, kaydka, iibka, deynta — waa laanta aad dooratay.",
  branchesHint: "Laan kasta waxay u shaqaysaa sidii farmashiye u gaar ah: daawooyinkeeda, qiimahooda, kaydkeeda, alaab-qeybiyeyaasheeda iyo macaamiisheeda.",
  addBranch: "Ku dar laan",
  branchLocation: "Meesha ay ku taal (ikhtiyaari)",
  branchAdded: (name: string) => `${name} waa lagu daray. Waxay ku bilaabataa madhan: ka beddel Bogga Hore si aad u diiwaangeliso daawooyinkeeda.`,
  youAreHere: "Halkan ayaad ka shaqaynaysaa",
  staffBranches: "Wuxuu ka shaqeeyaa",
  staffBranchesHint: "Waxay arkaan oo ka iibiyaan kaliya laamaha la calaamadeeyay.",
  owners: "Milkiilayaasha",
  ownersEverywhere: "Milkiilayaashu waxay ka shaqeeyaan laan kasta.",
  branchGroup: (name: string, n: number) => `${name} (${n})`,
  inNoBranch: "Laan kuma jiro",
  copy: "Koobiyee",
  copied: "La koobiyeeyay",
  staffLoginMessage: (pharmacy: string, username: string, password: string) =>
    `Galitaankaaga ${pharmacy}.\nMagaca isticmaalaha: ${username}\nFuraha sirta: ${password}\nFur app-ka oo dooro "Shaqaale".`,
  atLeastOneBranch: "Dooro ugu yaraan hal laan.",
  otherBranchesWrote: "Laamaha kale sidan ayay u qoreen:",

  /* ---------------------------------------------------------------- deyn */
  onCredit: "Deyn",
  /** A shop's credit sale, on its receipt: the day it is to be paid by. */
  payBy: "Ku bixi ka hor",
  balanceOwed: "Wadarta lagu leeyahay",
  creditCustomerName: "Magaca macmiilka",
  creditCustomerPhone: "Taleefanka macmiilka",
  creditNeedsCustomer: "Deynta waxay u baahan tahay magaca iyo taleefanka macmiilka, si loo helo mar dambe.",
  credits: "Daymaha",
  owedToYou: "Lagu leeyahay",
  debtAge: {
    days30: "0–30 maalmood",
    days60: "31–60 maalmood",
    days90: "61–90 maalmood",
    older: "Ka badan 90 maalmood",
  },
  nobodyOwes: "Cidna wax laguguma leh.",
  searchCustomers: "Ku raadi magac ama taleefan",
  noCustomerFound: "Macmiil ma jiro.",
  owes: (amount: string) => `Waxaa lagu leeyahay ${amount}`,
  paidUp: "Waxba laguguma leh",
  inCredit: (amount: string) => `Horay u bixiyay ${amount}`,
  recordPayment: "Diiwaangeli lacag bixin",
  paymentAmount: "Lacagta la bixiyay",
  paymentMoreThanOwed: (amount: string) => `Taasi waa ka badan tahay inta lagu leeyahay (${amount}). Waxaa loo hayaa horay u bixin.`,
  addCredit: "+ Ku dar deyn",
  addCreditTitle: "Ku dar deyn",
  creditAmount: "Lacagta lagu leeyahay",
  creditWhatFor: "Maxay u tahay (ikhtiyaari)",
  creditWhatForHint: "Tusaale: deyn hore oo buugga ku qornayd",
  creditDate: "Taariikhda",
  creditNotASale: "Iib ma aha: alaab ma dhaqaaqdo, iibkana kuma jirto. Marka la soo celiyo, waxay noqonaysaa lacag soo gashay.",
  creditSaved: "Deynta waa la diiwaangeliyay.",
  paymentSaved: "Lacag bixinta waa la diiwaangeliyay.",
  sendStatement: "Dir warbixinta xisaabta",
  statement: "Warbixinta xisaabta",
  statementFor: (month: string) => `Warbixinta xisaabta · ${month}`,
  owedAtStart: "Lagu lahaa bilowga",
  owedAtEnd: "Lagu leeyahay dhammaadka",
  nothingThisMonth: "Waxba bishan ma jiraan.",
  creditHistory: "Iibka deynta iyo lacag-bixinta",
  entryKind: {
    sale: (receipt: string) => `Iib deyn ah · rasiidka ${receipt}`,
    payment: (wallet: string | null) => (wallet ? `Lacag bixin · ${wallet}` : "Lacag bixin"),
    cancelled: (receipt: string) => `La joojiyay · rasiidka ${receipt}`,
    credit: "Deyn lagu daray",
    creditChanged: "Deyn lagu daray · la beddelay",
    creditCancelled: "Deyn lagu daray · la tirtiray",
  },
  givenOnCredit: "Deyn la bixiyay",
  creditPaidBack: "Deyn la soo celiyay",
  oldCreditInRevenue: (amount: string) => `Waxaa ku jira ${amount} oo deyn hore ah oo la soo celiyay, iib la'aan.`,
  creditPaidBackHint: "Horay ayaa loogu daray lacagta kor ku qoran.",

  /* ------------------------------------------------------------- reports */
  thisWeek: "Toddobaadkan",
  thisMonth: "Bishan",
  allBranches: "Dhammaan laamaha",
  salesTotal: "Iibka",
  salesCount: (n: number) => `${n} iib`,
  moneyReceived: "Lacagta la helay",
  noSalesInPeriod: "Wax iib ah muddadan ma jiro.",
  profit: "Faa'iido",
  costOfMedicines: "Qiimaha daawooyinka",
  revenue: "Dakhli",
  revenueOf: (amount: string) => `Dakhli ${amount}`,
  viewMore: (n: number) => `Arag dhammaan (${n})`,
  mostSoldHint: "Sida ay u badan yihiin inta la iibiyay.",
  deadStock: "Kayd aan dhaqaaqin",
  deadStockSubtitle: (days: number) => `Alaab aan la iibin ${days}-kii maalmood ee la soo dhaafay`,
  nothingDead: (days: number) => `Daawo kasta oo kayd leh waa la iibiyay ${days}-kii maalmood ee la soo dhaafay.`,
  lastSold: (date: string) => `Markii ugu dambeysay ee la iibiyay ${date}`,
  neverSold: "Weligeed lama iibin",
  staffActivity: "Waxqabadka shaqaalaha",
  staffActivityHint: "Cidda iibisay, joojisay, beddeshay ama kaydka beddeshay, iyo goorta.",
  everyone: "Dhammaan",
  noActivity: "Weli waxba ma jiraan.",
  reportsNeedInternet: "Warbixinnadu waxay u baahan yihiin xiriir. Xiriir oo isku day mar kale.",
  chooseDates: "Dooro taariikhaha",
  whichDays: "Maalmaha",
  rangeTooLong: "Dooro ugu badnaan laba sano markiiba.",
  sold: "La iibiyay",
  fromDate: "Laga bilaabo",
  toDate: "Ilaa",
  reportsFirstTime: "Warbixinnadu waxay u baahan yihiin internet hal mar, si tirooyinka loo keeno. Kadib waxay shaqeynayaan internet la'aan.",
  reportsUpTo: (when: string) => `internet-ka ma shaqeynaayo: tirooyinka ilaa ${when}, iyo iibka taleefankan tan iyo markaas.`,
  profitEstimate: "Waxaa ku jira iib aan weli la dirin, oo lagu xisaabiyay qiimaha celceliska dawo kasta.",
  deadStockAsOf: (when: string) => `internet-ka ma shaqeynaayo: liiska sidii uu ahaa ${when}.`,
  activity: {
    sale_created: (receipt: string, total: string) => `Wuxuu iibiyay rasiidka ${receipt} · ${total}`,
    sale_edited: (receipt: string) => `Wuxuu beddelay rasiidka ${receipt}`,
    sale_cancelled: (receipt: string) => `Wuxuu joojiyay rasiidka ${receipt}`,
    stock_recorded: (medicine: string, qty: string) => `Kayd la diiwaangeliyay: ${medicine} · ${qty}`,
    stock_changed: (medicine: string, qty: string) => `Kayd la beddelay: ${medicine} · ${qty}`,
    payment_recorded: (customer: string, amount: string, wallet: string | null) =>
      wallet ? `Lacag ka timid ${customer} · ${amount} · ${wallet}` : `Lacag ka timid ${customer} · ${amount}`,
    cost_corrected: (medicine: string, from: string, to: string, unit: string) =>
      `Qiimaha la saxay: ${medicine} · ${from} → ${to} ${unit} kasta`,
    medicine_added: (medicine: string) => `Daawo la daray: ${medicine}`,
    medicine_changed: (medicine: string) => `Daawo la beddelay: ${medicine}`,
    medicine_archived: (medicine: string) => `Daawo la kaydiyay: ${medicine}`,
    refused_sale_removed: (receipt: string) => `Iib aan la aqbalin ayaa laga saaray: rasiidka ${receipt}`,
  },
  soldOfflineAt: (time: string) => `la sameeyay iyadoo aan internet jirin ${time}`,

  /* ----------------------------------------------------- needs attention */
  needsAttention: "U baahan fiiro gaar ah",
  attentionCount: (n: number) => `${n} in la eego`,
  nothingNeedsAttention: "Wax u baahan fiiro gaar ah ma jiraan.",
  attentionRefused: "Iibyo aan la aqbalin",
  attentionRefusedHint:
    "Macmiilku wuu bixiyay oo alaabta wuu qaatay, laakiin iibka lama diiwaangelin. Sax waxa joojiyay, kadibna Isku day mar kale — ama Ka saar.",
  attentionBelowZero: "Daawooyin ka hooseeya eber",
  attentionBelowZeroHint: "Waxaa la iibiyay wax ka badan inta la diiwaangeliyay. Diiwaangeli kaydka shelf-ka yaal.",
  attentionExpiredSold: "Kayd dhacay oo la iibiyay, 7-dii maalmood ee la soo dhaafay",
  refusedBy: (seller: string, date: string) => `${seller} · ${date}`,
  removeRefused: "Ka saar",
  removeRefusedConfirm: "Iibkan ma ka saaraysaa liiska? Weligii lama diiwaangelin doono.",
  attentionChanges: "Joojin iyo beddel aan la samayn",
  attentionChangesHint:
    "Waxaa lagu sameeyay taleefan aan internet lahayn, laakiin iibka wax baa laga beddelay intaas ka hor. Dooro: beddelkan ku samee iibka sida uu hadda yahay, ama iibka sidiisa u daa.",
  refusedCancel: (receiptNo: string) => `Joojin · Rasiidh ${receiptNo}`,
  refusedEdit: (receiptNo: string) => `Beddel · Rasiidh ${receiptNo}`,
  makeThisChange: "Samee beddelkan",
  keepSaleAsIs: "Iibka sidiisa u daa",
  keepSaleConfirm: "Iibka sidiisa ma u daynaysaa? Beddelkan lama samayn doono.",
  expiredSoldLine: (qty: string, date: string) => `${qty} · wuu dhacay ${date}`,

  /* -------------------------------------------------------- out of stock */
  outOfStock: "Kayd ma jiro",
  runningLow: "Wuu yaraanayaa",
  runningLowHint: (n: number) => `Wuu yaraanayaa waxaa loola jeedaa in ka yar ${n} ayaa haray.`,
  nothingOutOfStock: (n: number) => `Daawo kasta waxaa ka haray ${n} ama ka badan.`,

  /* suppliers */
  suppliers: "Alaab-qeybiyayaasha",
  addSupplier: "Ku dar alaab-qeybiye",
  supplierName: "Magaca alaab-qeybiyaha",
  supplierTerms: "Shuruudaha lacag-bixinta",
  supplierTermsHint: "Qoraal furan, sida \"30 maalmood\" ama \"lacag caddaan ah\".",
  noSuppliersYet:
    "Weli alaab-qeybiye ma jiro. Waxaa lagu daraa marka kayd la qorayo, ama halkan.",

  /** Somali does not form a plural by adding a letter; the word stands as typed. */
  plural: (word: string, _n: number) => word,

  /* ----------------------------------------------------------- greetings */
  signedInAs: (name: string) => `Waxaad u gashay ${name}`,

  errors: {
    /* --- credentials --- */
    invalid_credentials: "Faahfaahintaas sax ma aha.",
    account_locked: "Xisaabtan waa la xiray. Milkiilaha weydiiso inuu furahaaga dib u dejiyo.",
    temporarily_locked: (minutes: number) =>
      `Isku dayo badan. Isku day mar kale ${minutes} daqiiqo gudahood.`,
    too_many_attempts: (minutes: number) =>
      `Isku dayo badan. Isku day mar kale ${minutes} daqiiqo kadib.`,
    password_too_short: (min: number) => `Isticmaal ugu yaraan ${min} xaraf.`,
    password_unchanged: "Dooro fure aadan hore halkan ugu isticmaalin.",
    weak_password: "Furahaas si fudud ayaa loo malayn karaa.",

    /* --- session --- */
    unauthenticated: "Fadlan mar kale gal.",
    invalid_access_token: "Fadlan mar kale gal.",
    invalid_refresh_token: "Fadlan mar kale gal.",
    refresh_token_reused: "Fadhigaaga waa la joojiyay sababo ammaan darteed. Fadlan mar kale gal.",
    pharmacy_deleted: "Farmashiyahan waa la tirtiray. 30 maalmood gudahood kadib tirtirka, taageeradu way soo celin kartaa.",
    /* --- which app (FarmashiBook or DukaanBook) --- */
    wrong_app: "Xisaabtani waxay ka tirsan tahay DukaanBook. Halkaas ka gal.",
    unknown_app: "Barnaamijkan lama yaqaan.",
    invalid_product: "Hubi cabbirada iyo qiimaha alaabta.",
    missing_request_context: "Wax baa qaldamay. Fadlan mar kale gal.",

    /* --- verification --- */
    invalid_code: "Koodhkaas waa qalad ama wuu dhacay. Mid cusub codso.",
    invalid_verification_token: "Waqti badan ayaa qaatay. Dib u bilow.",
    verification_already_used: "Koodhkaas hore ayaa loo isticmaalay. Mid cusub codso.",
    too_many_codes: "Koodh badan ayaa la codsaday. Sug dhowr daqiiqo.",
    too_many_sms: (minutes: number) =>
      `Isku day mar kale ${minutes} daqiiqo kadib, ama isticmaal iimaylkaaga. Koodhadhka SMS-ka waa xaddidan yihiin.`,
    codes_unavailable: "Hadda koodh lama diri karo. Isku day mar dambe.",
    email_already_registered: "Iimaylkaas hore ayaa loo isticmaalay.",
    contact_phone_required: "Geli lambarka taleefanka farmashiyaha.",
    already_yours: "Kaasi hore ayaad ku gashaa.",
    invalid_target: "Geli lambar taleefan ama iimayl.",
    phone_already_registered: "Lambarkaas hore ayaa loo isticmaalay.",
    invitation_not_found: "Casuumaaddaas ma shaqaynayso. Milkiilaha weydiiso mid kale.",

    /* --- people and permissions --- */
    forbidden: "Ma haysatid oggolaansho arrintan.",
    username_taken: "Magacaas hore ayaa loo isticmaalay. Isku day mid ka mid ah soo jeedinta.",
    staff_limit_reached: "Waxaad isticmaashay dhammaan xisaabaha shaqaalaha ee qorshahaaga.",
    not_main_owner: "Milkiilaha guud keliya ayaa samayn kara tan.",
    cannot_change_yourself: "Tan kuma samayn kartid akoonkaaga.",
    owner_invitation_pending: "Weli ma aqbalin martiqaadka.",
    owner_not_active: "Milkiile firfircoon keliya ayaa noqon kara milkiilaha guud.",
    main_owner_cannot_leave: "Marka hore milkiile kale ka dhig milkiilaha guud.",
    branch_limit_reached: "Qorshahaagu ma oggola laan kale.",
    plan_expired: "Qorshahaagu waa dhammaaday. Wax walba waad arki kartaa, laakiin iib ama kayd cusub ma dari kartid ilaa la cusbooneysiiyo. Xogtaadu way badbaadsan tahay.",
    cannot_edit_admin: "Xisaabaha milkiilaha halkan lagama maamulo.",
    cannot_reset_admin: "Milkiiluhu furahiisa wuxuu ku soo celiyaa taleefanka.",
    invalid_branch: "Laantaas ma diyaar aha.",

    /* --- products and stock --- */
    barcode_taken: "Barcode-kaas alaab kale ayaa leh.",
    category_not_found: "Qaybtaas mar dambe ma jirto.",
    supplier_not_found: "Alaab-qeybiyahaas mar dambe ma jiro.",
    unknown_size: "Cabbirkaas alaabtan kuma jiro.",
    size_exists: "Daawadan horey ayey u leedahay cabbir intaas haya.",
    invalid_stock: "Hubi waxaad u qortay kaydkan.",
    expired_stock_needs_confirmation: "Kaydkan horey ayuu u dhacay.",
    invalid_stock_movement: "Taasi tiro sax ah ma aha.",

    invalid_adjustment: "Hubi tirada cusub iyo sababta.",
    count_needs_stock: "Weli kayd ma laha. Wixii yimid ku qor Ku dar alaab.",
    invalid_sale: "Hubi qiimayaasha iyo lacag-bixinta.",
    sale_changed: "Qof kale ayaa beddelay iibkan. Mar kale fur.",
    sale_cancelled: "Iibkan waa la joojiyay.",
    sale_has_credit: "Iibkaas hore ayaa deyn ku jirtaa. Ka beddel iibka laftiisa.",
    credit_more_than_sale: "Deyntu kama badnaan karto lacagta iibkaas la bixiyay.",
    link_too_late: "Deyn waxaa lagu dari karaa kaliya iib 30-kii maalmood ee la soo dhaafay.",
    cancel_too_late: "Iib waxaa la joojin karaa kaliya 14 maalmood gudahood.",
    edit_too_late: "Iib waxaa la beddeli karaa kaliya 30 maalmood gudahood.",
    note_required: "Sheeg waxa dhacay.",

    /* --- transfers --- */
    same_branch: "Dooro laan kale: tani waa laanta aad joogto.",
    already_received: "Wareejintan horay ayaa loo helay.",
    not_received: "Wareejintan weli lama helin.",
    correct_too_late: "Tirada waxaa la sixi karaa hal toddobaad oo keliya kadib helitaanka.",
    less_than_arrived: "Kama yaraan karto waxa yimid.",
    already_used: "Qaar ka mid ah horay ayaa loo iibiyay ama loo wareejiyay.",
    not_whole_units: "Taasi ma samaynayso cutubyo dhammaystiran oo dawadaada ah.",
    different_unit: "Dawadaas waxaa lagu tiriyaa cutub aan u dhigmin.",
    every_line: "Wax ka sheeg dawo kasta.",
    invalid_receipt: "Hubi waxa yimid iyo sababaha.",
    base_size_needed: "Cabbirka ugu yar wuxuu u baahan yahay qiime.",

    /* --- catch-alls --- */
    validation_failed: "Hubi faahfaahinta aad gelisay.",
    not_found: "Taasi halkan ma joogto.",
    too_many_requests: "Server-ku hadda wuu mashquulsan yahay. Isku day wax yar kadib.",
    took_too_long: "Waqti badan ayay qaadatay. Mar kale isku day.",
    report_too_long: "Waqti badan ayay qaadatay. Dooro maalmo ka yar, mar kalena isku day.",
    network: "Server-ka lama gaari karin. Hubi xiriirkaaga.",
    timeout: "Server-ku waqti badan ayuu qaatay inuu jawaabo.",
    unknown: "Wax baa qaldamay.",
  },
};

export default so;
